<template>
  <div class="p-5">
  <span>Copyright © 一楼一凤 All rights reserved.</span>
  </div>
</template>

<script>
export default {
  name: 'foot'
}
</script>

<style scoped>
.p-5 {
  font-size: 14px;
  padding: 3rem!important;
}
</style>



// WEBPACK FOOTER //
// src/components/base/foot.vue